export class ClassTimeSchedule {
    constructor(startTime, endTime) {
        this.startTime = startTime;
        this.endTime = endTime;
        this.errorGreaterThan =
            startTime.dataset["errorGreaterThan"] ??
                endTime.dataset["errorGreaterThan"] ??
                "End time must be greater than end time";
    }
    static create(form) {
        const startTime = form.querySelector(this._startTimeSelector);
        if (startTime === null) {
            throw new Error(`Element with ${this._startTimeSelector} not found`);
        }
        const { timeGroup } = startTime.dataset;
        if (timeGroup === undefined) {
            throw new Error(`Element with ${this._startTimeSelector} must have a data-time-group attribute`);
        }
        const endTime = form.querySelector(`.js-end-time[data-time-group='${timeGroup}']`);
        if (endTime === null) {
            throw new Error("Element with .js-end-time must have a data-time-group");
        }
        return new ClassTimeSchedule(startTime, endTime);
    }
    validate() {
        if (ClassTimeSchedule.toInt(this.startTime.value) >=
            ClassTimeSchedule.toInt(this.endTime.value)) {
            return this.errorGreaterThan;
        }
        return null;
    }
    static toInt(time) {
        const timeParts = time.split(":");
        return parseInt(timeParts[0]) * 100 + parseInt(timeParts[1]);
    }
}
ClassTimeSchedule._startTimeSelector = ".js-start-time";
